import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";

import { auth } from "/apollo/client/local";
import { hasFeatureFlagEnabled } from "/util/featureFlags/featureFlags";

import AccountIndex from "./page/AccountIndex";
import AthenaBilling from "./page/AthenaBilling";
import CaregiverDeprecated from "./page/CaregiverIndex/CaregiverDeprecated";
import Feedback from "./page/Feedback";
import InsuranceB2C from "./page/InsuranceB2C";
import Message from "./page/Message";
import Messages from "./page/Messages";
import PersonalInformationB2C from "./page/PersonalInformationB2C";
import Settings from "./page/Settings";

const AccountRoutes = ({ match }: RouteComponentProps) => {
  const { isAuthenticated } = useReactiveVar(auth.var);
  return (
    <Switch>
      <Route exact path={match.url} component={AccountIndex} />
      {isAuthenticated ? (
        <Switch>
          {hasFeatureFlagEnabled("personal_info_enabled") && (
            <Route
              exact
              path={`${match.url}/personal-information`}
              component={PersonalInformationB2C}
            />
          )}
          {hasFeatureFlagEnabled("insurance_enabled") && (
            <Route exact path={`${match.url}/insurance`} component={InsuranceB2C} />
          )}
          {process.env.FEATURE_ENABLE_ATHENA_BILLING === "true" && (
            <Route path={`${match.url}/billing-accounts`} component={AthenaBilling} />
          )}
          <Route exact path={`${match.url}/messages`} component={Messages} />
          <Route exact path={`${match.url}/messages/sent`} component={Messages} />
          <Route exact path={`${match.url}/messages/:id`} sensitive component={Message} />
          <Route exact path={`${match.url}/messages/sent/:id`} sensitive component={Message} />
          <Route exact path={`${match.url}/settings`} component={Settings} />

          {process.env.FEATURE_ENABLE_FEEDBACK === "true" && (
            <Route exact path={`${match.url}/feedback`} component={Feedback} />
          )}
          <Switch>
            <Route exact path={`${match.url}/caregiver`} component={CaregiverDeprecated} />
          </Switch>
        </Switch>
      ) : (
        <Redirect to={`${match.url}`} />
      )}
    </Switch>
  );
};

export default AccountRoutes;
